import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  sitemapPaper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    '@media (min-width: 640px)': {
      margin: '16px 24px',
      flexDirection: 'row',
    },
  },
  mapContainer: {
    position: 'relative',
    flex: 3,
    minHeight: '500px',
    '@media (min-width: 640px)': {
      minHeight: 'unset',
      maxWidth: '75%',
    },
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  buildingsContainer: {
    gap: '24px',
    padding: '16px 24px',
    flex: 1,
  },
  buildingDetailsList: {
    gap: '10px',
  },
  buildingsHeading: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '30px',
    letterSpacing: '0em',
    textAlign: 'left',
  },
  propertyTypeHeading: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '18px',
    color: theme.evPalette.charcoal[800],
    textTransform: 'uppercase',
  },
  propertyType: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '16px',
  },
}));
